import React from 'react'

import SelectWithSearch, {SelectOption} from './SelectWithSearch'

interface AttendanceSchoolSelectProps {
  options: SelectOption[]
  onSelect: (value: string) => void
  onSearchChange?: (term: string) => void
  selectedValue?: string | null
  theme?: 'light' | 'dark'
  placeholder?: string
  emptyMessage?: string
  listMaxHeight?: number
}

const AttendanceSchoolSelect: React.FC<AttendanceSchoolSelectProps> = ({
  options,
  onSelect,
  onSearchChange,
  selectedValue,
  theme = 'light',
  placeholder = 'Search...',
  emptyMessage = 'No items found',
  listMaxHeight = 240,
}) => {
  return (
    <SelectWithSearch
      options={options}
      onSelect={onSelect}
      onSearchChange={onSearchChange}
      selectedValue={selectedValue}
      theme={theme}
      placeholder={placeholder}
      emptyMessage={emptyMessage}
      listMaxHeight={listMaxHeight}
    />
  )
}

export default AttendanceSchoolSelect
